export const productWorkflowVersion = "strategy-product-workflows-0.1.0";

export const productWorkflows = [
  {
    id: "executive-expansion-workflow",
    domainId: "executive",
    label: "Executive Expansion Decision",
    steps: ["define objective", "attach evidence", "score options", "review gates", "export decision receipt"],
    requiredOutputs: ["score", "gate status", "missing evidence", "blocked claims", "next action", "decision receipt"],
    blockedClaims: ["market outcome guarantee", "production readiness without live proof"]
  },
  {
    id: "personal-reversible-decision-workflow",
    domainId: "personal",
    label: "Personal Reversible Decision",
    steps: ["state options", "check reversibility", "check values and energy", "score options", "export clarity receipt"],
    requiredOutputs: ["score", "reversibility status", "values/energy notes", "missing evidence", "next action", "clarity receipt"],
    blockedClaims: ["medical advice", "mental health diagnosis"]
  },
  {
    id: "trading-research-thesis-workflow",
    domainId: "trading",
    label: "Trading Research Thesis",
    steps: ["record thesis", "attach data snapshot", "define invalidation", "score research quality", "export research receipt"],
    requiredOutputs: ["score", "live-data blocker", "risk boundary", "invalidation", "missing evidence", "research receipt"],
    blockedClaims: ["financial advice", "profit guarantee", "trade recommendation"]
  },
  {
    id: "negotiation-lawful-communication-workflow",
    domainId: "negotiation",
    label: "Lawful Communication Plan",
    steps: ["map stakeholders", "check lawful path", "review coercion risk", "score message fit", "export communication receipt"],
    requiredOutputs: ["score", "coercion-risk gate", "lawful path", "blocked claims", "next action", "communication receipt"],
    blockedClaims: ["coercive manipulation", "unlawful deception"]
  },
  {
    id: "operating-release-governance-workflow",
    domainId: "operating",
    label: "Release Governance Loop",
    steps: ["check source ledger", "run release gate", "compare receipts", "confirm rollback path", "export release receipt"],
    requiredOutputs: ["local readiness", "artifact hashes", "deployment blockers", "rollback status", "blocked claims", "release receipt"],
    blockedClaims: ["automation without rollback", "source-free status claims"]
  }
];

export function productWorkflowSummary(workflows = productWorkflows) {
  return {
    version: productWorkflowVersion,
    workflows: workflows.length,
    steps: workflows.reduce((total, workflow) => total + workflow.steps.length, 0),
    requiredOutputs: workflows.reduce((total, workflow) => total + workflow.requiredOutputs.length, 0),
    productionClaim: false,
    claimBoundary:
      "Product workflows define app behavior and receipt outputs only. They do not provide professional advice or autonomous authority."
  };
}
